import React from "react";

const useSuppressionImporter = () => {
  const [addSuppressionDialogOpen, setAddSuppressionDialogOpen] =
    React.useState(false);

  const [suppressionImporterOpen, setSuppressionImporterOpen] =
    React.useState<boolean>(false);

  const openSuppressionImporter = React.useCallback(() => {
    setSuppressionImporterOpen(true);
  }, []);

  const closeSuppressionImporter = React.useCallback(() => {
    setSuppressionImporterOpen(false);
  }, []);

  const openAddSuppressionDialog = React.useCallback(() => {
    setAddSuppressionDialogOpen(true);
  }, []);

  const closeAddSuppressionDialog = React.useCallback(() => {
    setAddSuppressionDialogOpen(false);
  }, []);

  return {
    suppressionImporterOpen,
    openSuppressionImporter,
    closeSuppressionImporter,
    addSuppressionDialogOpen,
    openAddSuppressionDialog,
    closeAddSuppressionDialog,
  };
};

export default useSuppressionImporter;
